if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.swiper = null; // Initialize swiper variable
        this.setupImageClick();
      }

      hide() {
        this.resetAllZoom();
        super.hide();
      }

      resetAllZoom() {
        this.querySelectorAll('.imageAreaMain').forEach((slide) => {
          slide.classList.remove('zoomOutImg');
          const img = slide.querySelector('.product-image, .global-media-settings--no-shadow');
          if (img) {
            img.classList.remove('zoomed');
            if (img._zoomInstance) {
              img._zoomInstance.reset();
            }
          }
        });
      }



      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        const swiperContainer = this.querySelector('.modalSwiper');       
        if (swiperContainer) {
          if (!this.swiper) {
            this.initializeSwiper(); // Initialize Swiper if not already done
          } else {
            this.swiper.update(); // Update Swiper if already initialized
          }
        }
      }

      showActiveMedia() {
        const activeId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${activeId}"]`);
        activeMedia.classList.add('active');

        const index = parseInt(activeMedia.getAttribute('data-swiper-slide-index'), 10);
        
        if (this.swiper && this.swiper.activeIndex !== index) {
          this.swiper.slideTo(index, 0); // Update Swiper slide
        }

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // Load deferred media content if needed
        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          const activeMediaContent = activeMedia.querySelector('template')?.content;
          if (activeMediaContent?.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }

      setupImageClick() {
        this.addEventListener('click', (event) => {
          const image = event.target.closest('.product-image');
          if (image) {
            event.stopPropagation();
            image.classList.toggle('zoomed');
            const targetElement = image.closest('.imageAreaMain');
            targetElement.classList.toggle("zoomOutImg");
            this.openedBy = image;
            this.show(image);
          }
        });
      }

      initializeSwiper() {
        const swiperContainer = this.querySelector('.modalSwiper');
        if (swiperContainer) {
          this.swiper = new Swiper(swiperContainer, {
            allowTouchMove: true,
            loop: false,
            zoom: {
              maxRatio: 3, // Maximum zoom level
            },
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            navigation: {
              nextEl: '.swiper-modal-next',
              prevEl: '.swiper-modal-prev',
            },
            pagination: {
              el: null,
            },
            // on: {
            //   slideChange: () => {
            //     const activeIndex = this.swiper.activeIndex;
            //     const activeSlide = this.swiper.slides[activeIndex];
            //     const mediaId = activeSlide.getAttribute('data-media-id');
            //     this.openedBy = this.querySelector(`[data-media-id="${mediaId}"]`);
            //     this.showActiveMedia(); // Sync the media to the active slide
            //   },
            // },
            on: {
              init: () => {
                setTimeout(() => {
                  this.updateCustomPagination();
                }, 100);
              },
            slideChange: () => {
              // Reset zoom whenever the active slide changes (next/prev navigation)
              this.resetAllZoom();


              const activeIndex = this.swiper.activeIndex;
              const activeSlide = this.swiper.slides[activeIndex];
              
              // Pause all videos
              // this.querySelectorAll('video').forEach(video => {
              //   video.pause();
              // });
          
              // Load active media
              const mediaId = activeSlide.getAttribute('data-media-id');
              this.openedBy = this.querySelector(`[data-media-id="${mediaId}"]`);
              this.showActiveMedia();
              this.updateCustomPagination();
          
              // Check if the active slide contains a video
              // const videoElement = activeSlide.querySelector('video');
              // if (videoElement) {
              //   videoElement.play(); // Play the video if it's present
              // }
            },
          }
          });
          // this.updateCustomPagination();
        }
      }

  updateCustomPagination() {
    const paginationContainer = this.querySelector('.swiper-modal-pagination');
    const totalSlides = this.swiper.slides.length;
    const currentIndex = this.swiper.activeIndex;

    paginationContainer.innerHTML = '';
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('span');
      dot.classList.add('swiper-pagination-bullet');
      if (i === currentIndex) {
        dot.classList.add('swiper-pagination-bullet-active');
      }
      dot.addEventListener('click', () => {
        this.swiper.slideTo(i);
        this.updateCustomPagination();
      });
      paginationContainer.appendChild(dot);     
    }
  }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const productModal = document.querySelector('product-modal');
  if (productModal) {
    const slides = productModal.querySelectorAll('.swiper-slide');
    slides.forEach((slide, index) => {
      slide.setAttribute('data-swiper-slide-index', index);
    });
    // Initialize the Swiper here instead of in the modal
    const swiperContainer = productModal.querySelector('.modalSwiper');
    if (swiperContainer) {
      productModal.initializeSwiper();
    }
  }
});


